export default "__VITE_ASSET__CanZr5TE__"